import reduce from 'lodash/reduce';

const Constants = [
    // User
    'UPDATE_USER_INFO',

    // Address
    'ADDRESS_AUTO_COMPLETE',
    'ADDRESS_DETAILS',

    // Lead
    'LEAD_ALL_LEADS_SUCCESS',
    'LEAD_ALL_LEADS_FAIL',
    'LEAD_FOR_LISTING_SUCCESS',
    'LEAD_FOR_LISTING_FAIL',
    'LEAD_SUCCESS',
    'LEAD_FAIL',

    // Reviews
    'REVIEWS_FOR_LISTING_GET_SUCCESS',
    'REVIEW_RESPONSE_UPDATE_SUCCESS',
    'REVIEW_RESPONSE_DELETE_SUCCESS',
    'REVIEW_REPORT_SUCCESS',

    // Properties
    'UPDATE_CURRENT_PROPERTY',
    'UPDATE_PROPERTIES',
    'UPDATE_PROPERTIES_COUNT',
    'UPDATE_PROPERTIES_FILTERS',
    'UPDATE_PROPERTIES_CONVERSION',

    // App
    'TRANSITION_TO',
    'UPDATE_APP',
    'UPDATE_LOCATION',
    'SCREEN_DIMENSION_CHANGE',
    'INITIALIZE_FEATURE_FLAGS',
    'UPDATE_FEATURE_FLAG',

    // Statistics
    'STATS_GET_SUCCESS',
    'STATS_GET_FAIL',

    // Notification settings
    'NOTIFICATION_SETTINGS_GET_SUCCESS',
    'NOTIFICATION_SETTINGS_UPDATE_SUCCESS',

    // Scheduler
    'SCHEDULER_UPDATE_SUCCESS',
    'SCHEDULER_UPDATE_FAIL',

    // Analytics
    'ANALYTIC_AD_PRODUCTS_GET_SUCCESS',
    'ANALYTIC_AD_PRODUCTS_GET_FAIL',
    'ANALYTICS_PROPERTIES_GET_SUCCESS',
    'ANALYTICS_PROPERTIES_GET_FAIL',
    'ANALYTICS_BOOST_AD_GET_SUCCESS',
    'ANALYTICS_BOOST_AD_GET_FAIL',
    'ANALYTICS_BOOST_AD_PREVIEWS_GET_LOADING',
    'ANALYTICS_BOOST_AD_PREVIEWS_GET_SUCCESS',
    'ANALYTICS_BOOST_AD_PREVIEWS_GET_FAIL',
    'ANALYTICS_OVERVIEW_GET_SUCCESS',
    'ANALYTICS_OVERVIEW_LISTINGS_GET_FAIL',
    'ANALYTICS_OVERVIEW_REVIEWS_GET_FAIL',
    'ANALYTICS_OVERVIEW_INVOICES_GET_FAIL',
    'ANALYTICS_OVERVIEW_ALL_LISTINGS_GET_SUCCESS',
    'ANALYTICS_OVERVIEW_ALL_LISTINGS_GET_FAIL',
    'ANALYTICS_OVERVIEW_FILTER_GET_SUCCESS',
    'ANALYTICS_OVERVIEW_FILTER_GET_FAIL',
    'ANALYTICS_PROPERTY_RENT_COMPARISON_GET_SUCCESS',
    'ANALYTICS_PROPERTY_RENT_COMPARISON_GET_FAIL',
    'ANALYTICS_COMPETITION_SET_LOADING_STATE',
    'ANALYTICS_COMPETITION_CLEAR',

    // AnalyticsStore
    'LOAD_AB_TEST_EXPERIMENTS',
    'ENROLL_AB_TEST_EXPERIMENT',
    'RESET_PAGE_CUSTOM_VARS',
    'UPDATE_PAGE_CUSTOM_VARS',

    'UPDATE_CURRENT_PAGE',

    // Email Verification
    'UPDATE_EMAIL_VERIFICATION',

    // Modal
    'MODAL_SHOW',
    'MODAL_HIDE',
    'MODAL_UPDATE',

    // Paid Inclusion
    'INITIATE_CREDIT_CARD_CAPTURE_SUCCESS',
    'INITIATE_CREDIT_CARD_CAPTURE_FAIL',
    'VERIFY_CREDIT_CARD_CAPTURE_SUCCESS',
    'VERIFY_CREDIT_CARD_CAPTURE_FAIL',
    'CREDIT_CARD_FORM_LOADING',
    'CREDIT_CARD_FORM_LOAD_COMPLETE',
    'CREDIT_CARD_FORM_SUBMITTING',
    'CREDIT_CARD_FORM_SUBMIT_SUCCESS',
    'CREDIT_CARD_FORM_SUBMIT_FAIL',
    'INITIATE_CREDIT_CARD_CHARGE',
    'INITIATE_CREDIT_CARD_CHARGE_SUCCESS',
    'INITIATE_CREDIT_CARD_CHARGE_PENDING',
    'LISTING_CANNOT_BE_ACTIVATED',
    'INITIATE_CREDIT_CARD_CHARGE_FAIL',
    'INITIATE_CREDIT_CARD_CHARGE_VALID_PAYMENT_EXISTS',
    'PERFORM_CHARGE',
    'PERFORM_CHARGE_SUCCESS',
    'PERFORM_CHARGE_FAIL',
    'VERIFY_PAYMENT_AND_ACTIVATE_LISTING_SUCCESS',
    'VERIFY_PAYMENT_AND_ACTIVATE_LISTING_FAIL',
    'DEFAULT_PAYMENT_SUCCESS',
    'DEFAULT_PAYMENT_FAIL',
    'GET_PAID_INCLUSION_PRICE_SUCCESS',
    'GET_PAID_INCLUSION_PRICE_FAIL',
    'PAID_INCLUSION_DETAILS_SUCCESS',
    'PAID_INCLUSION_DETAILS_FAIL',

    // Claim listing
    'CLAIM_UPDATE_LISTINGS_TO_CONVERT',
    'CLAIM_UPDATE_CONTACT_METHODS',
    'CLAIM_SET_CONTACT_METHODS_LOADING_STATE',
    'CLAIM_SHOW_PROPERTY_LOOKUP_MODAL',

    // Ab Testing
    'SETUP_AB_TESTS',
    'ENROLL_USER_IN_AB_TEST',

    // Env
    'SET_ENV',

    // BILLING
    'BILLING_SET_LOADING_STATE',
    'BILLING_SET_ERROR_MESSAGE',
    'BILLING_SET_FILTERS',
    'BILLING_SET_INVOICE_FILTERS',
    'BILLING_IMPORT_INVOICES',
    'BILLING_IMPORT_INVOICE',
    'BILLING_SET_INVOICE_DOWNLOAD_STATE',
    'BILLING_SET_INVOICE_DOWNLOAD_ERROR_MESSAGE',
    'BILLING_SET_CURRENT_INVOICE_LOADING_STATE',
    'BILLING_SET_CURRENT_INVOICE_ERROR_MESSAGE',
    'BILLING_SET_CURRENT_INVOICE_PAYMENT_IN_PROGRESS',
    'BILLING_SET_MULTIFAMILY_FILTER_OPTIONS',
    'BILLING_CLEAR_INVOICES',
    'BILLING_CLEAR_CURRENT_INVOICE',
    'BILLING_PAYMENT_METHODS_INIT',
    'BILLING_PAYMENT_METHODS_SET_LOADING_STATE',
    'BILLING_PAYMENT_METHODS_SET_PAYMENT_METHODS',
    'BILLING_ACCOUNT_PAYMENT_METHODS_INIT',
    'BILLING_ACCOUNT_PAYMENT_METHODS_SET_LOADING_STATE',
    'BILLING_ACCOUNT_PAYMENT_METHODS_SET_PAYMENT_METHODS',
    'BILLING_ACCOUNT_PAYMENT_METHODS_SET_PAYMENT_METHOD_LOCK',
    'BILLING_USER_SETTINGS_SET_USER_HAS_METHODS',
    'BILLING_USER_SETTINGS_INIT',

    // Customer payments
    'BILLING_SET_PAYMENT_SESSION_INFO',
    'BILLING_SET_PAYMENT_SESSION_INFO_STATE',
    'BILLING_SET_PAY_INVOICE_STATE',
    'BILLING_SET_PAYMENT_DISPLAY_SUCCESS',

    // User Management
    'USER_MANAGEMENT_SET_COMPANY_NAME',
    'USER_MANAGEMENT_GET_COMPANY_LOADING',
    'USER_MANAGEMENT_GET_COMPANY_SUCCESS',
    'USER_MANAGEMENT_GET_COMPANY_FAIL',
    'USER_MANAGEMENT_GET_USERS_LOADING',
    'USER_MANAGEMENT_GET_USERS_SUCCESS',
    'USER_MANAGEMENT_GET_USERS_FAIL',
    'USER_MANAGEMENT_UPDATE_USERS_LOADING',
    'USER_MANAGEMENT_UPDATE_USERS_SUCCESS',
    'USER_MANAGEMENT_UPDATE_USERS_FAIL',
    'USER_MANAGEMENT_SET_ACTIVITY_HISTORY',
    'USER_MANAGEMENT_SET_ACTIVITY_HISTORY_LOADING_STATE',
    'USER_MANAGEMENT_SET_ACTIVITY_HISTORY_ERROR',
    'USER_MANAGEMENT_ACTIVITY_HISTORY_INIT',
    'USER_MANAGEMENT_GET_CURRENT_USER_INFO_LOADING',
    'USER_MANAGEMENT_GET_CURRENT_USER_INFO_SUCCESS',
    'USER_MANAGEMENT_GET_CURRENT_USER_INFO_FAIL',
    'USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_LOADING',
    'USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_SUCCESS',
    'USER_MANAGEMENT_GET_CURRENT_USER_PROPERTIES_FAIL',
    'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_LOADING',
    'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_SUCCESS',
    'USER_MANAGEMENT_GET_EDITABLE_PROPERTIES_FAIL',
    'USER_MANAGEMENT_SET_USERS_NOTIFICATION',
    'USER_MANAGEMENT_CURRENT_USER_INIT',
    'USER_MANAGEMENT_EDITABLE_USER_LOAD',
    'USER_MANAGEMENT_SET_CURRENT_USER_EMAIL',
    'USER_MANAGEMENT_SET_CURRENT_USER_NAME',
    'USER_MANAGEMENT_SET_CURRENT_USER_PROPERTIES',
    'USER_MANAGEMENT_SET_EDITABLE_USER_PERMISSION',
    'USER_MANAGEMENT_SET_CURRENT_USER_PERMISSIONS',
    'USER_MANAGEMENT_SET_EDITABLE_USER_LOADING_STATE',
    'USER_MANAGEMENT_INIT_INVITATION',
    'USER_MANAGEMENT_SET_CURRENT_USER_AVAILABLE_PROPERTIES',
];

const DispatchConstants = reduce(
    Constants,
    (accumulator, value) => {
        accumulator[value] = value;
        return accumulator;
    },
    {}
);

export default DispatchConstants;
